import { notSupportedReason, supported } from '@mapbox/mapbox-gl-supported';
import { useState } from 'react';

type WebGLSupport = { supported: boolean; reason?: string };

let cached: WebGLSupport | undefined;

const check = (): WebGLSupport => {
    if (cached) {
        return cached;
    }

    const opts = { failIfMajorPerformanceCaveat: true };
    const isSupported = supported(opts);
    cached = { supported: isSupported, reason: isSupported ? undefined : notSupportedReason(opts) };

    return cached;
};

export const useWebGLSupported = (): WebGLSupport => useState(check)[0];
